/**
 * Scope-of-use statement shown at the top of the Terms and Privacy pages.
 * One component so both pages carry identical wording.
 */
export function LegalScopeNotice() {
  return (
    <div className="p-4 rounded-lg border border-border bg-muted/30 text-sm text-muted-foreground mb-8 space-y-2">
      <p>
        We follow these terms to the best of our knowledge of the rules that
        applied to the use of this site at the time it was developed. Local
        laws or regulations that differ from the usage terms stated here are
        outside the purview of FreeDailyPro and its holding company. No legal
        review, legal advice or legal liability is provided or accepted.
      </p>
      <p>
        It is the responsibility of the user and of local authorities to bring
        any difference to our notice. We will try to assist and to adhere to it
        to the best of our abilities. If adhering to the requirements of a
        specific user or authority would affect the use of the site by other
        users, then that user or authority is responsible for taking action to
        avoid using the particular tool or site capability.
      </p>
      <p>
        Document templates and calculators are provided as general starting
        points to the best of our knowledge. Check them with your own attorney
        or adviser before relying on them.
      </p>
    </div>
  );
}
